import React from "react";
import styles from "../../styles/HomePage.module.css";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section className={styles.hero}>
      <div className={`${styles.container} ${styles.heroContent}`}>
        <h1>Find Your Perfect Used Car</h1>
        <p>
          Thousands of certified used cars to choose from with warranty and easy
          financing options
        </p>
        <Link to={"/booking/carlisting"} className={styles.btn}>
          Browse Cars
        </Link>
      </div>
    </section>
  );
};

export default HeroSection;
